import '@shared/styling/vuetify.scss';
import '@shared/styling/vuetify-override.scss';
import { createVuetify } from 'vuetify';

const semboTheme = {};

export const vuetify = (locale: string) =>
    createVuetify({
        locale: {
            locale,
        },
        theme: {
            defaultTheme: 'semboTheme',
            themes: { semboTheme },
        },
    });
